/*
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2024, Zumper
 * @description
 */

import { createSettingInterface } from '@zcode/settings'
import { Setting } from './constants'
import { APP_HOSTNAME } from './settings'

const { createSetting, freeze } = createSettingInterface()

export const IS_ZUMPER_RENTALS: boolean = createSetting(
  Setting.IS_ZUMPER_RENTALS,
  APP_HOSTNAME.includes('zumperrentals.com')
)

freeze()
